module.exports = __webpack_public_path__ + "static/media/use-case-4.101a5759.svg";